import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import GridList from 'modules/documents/components/GridList'

interface Props {
  key: string
}

const FolderListItemSkeleton = ({ key }: Props) => {
  return (
    <GridList.ListItem disableClick key={key}>
      <Box gap="s16" paddingX="s24" paddingY="s24">
        <Box gap="s16" flexDirection="row" alignItems="center">
          <Skeleton height="s32" width="s32" />
          <Box gap="s12">
            <Skeleton height="s12" width="s140" />
            <Skeleton height="s8" width="s80" />
          </Box>
        </Box>
      </Box>
    </GridList.ListItem>
  )
}

export default FolderListItemSkeleton
